import React from 'react'
import { isEmpty } from 'lodash'

const defLocations = [
  {
    id: 1,
    city: 'Jakarta - HQ',
    address:
      'Traveloka Campus - North Tower Jl. BSD Green Office Park No. 1 BSD City, Tangerang 15345 Indonesia ',
    country: 'Indonesia-id',
  },
]

const LocationContext = React.createContext()

export const useLocations = () => {
  const locations = React.useContext(LocationContext)

  if (locations === undefined) {
    throw new Error('useLocations must be used within a component wrapped with LocationCtxProvider')
  }

  return isEmpty(locations) ? defLocations : locations
}

export function withLocations(Component) {
  class EnhancedComponent extends React.Component {
    render() {
      const { forwardedRef, ...rest } = this.props
      return (
        <LocationContext.Consumer>
          {locations => (
            <Component
              ref={forwardedRef}
              {...rest}
              locations={isEmpty(locations) ? defLocations : locations}
            />
          )}
        </LocationContext.Consumer>
      )
    }
  }

  return React.forwardRef((props, ref) => <EnhancedComponent forwardedRef={ref} {...props} />)
}

export function LocationCtxProvider(props = {}) {
  const { locations = [], children } = props

  // add concat to make it immutable
  const sortedLocations = sortLocations(locations.concat([]));

  return <LocationContext.Provider value={sortedLocations}>{children}</LocationContext.Provider>
}

function sortLocations(locations) {
  // HQ first, then alphabetical
  const hqIndex = locations.findIndex(location => {
    return location.country === 'Indonesia-id'
  });

  if (hqIndex === -1) {
    return locations.sort((a, b) => {
      return a.city > b.city ? 1 : -1
    })
  }

  const hq = locations.splice(hqIndex, 1);
  return hq.concat(locations.sort((a, b) => {
    return a.city > b.city ? 1 : -1;
  }))
}

export default LocationCtxProvider
